import type { canv } from "@/canv/global";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import { checkIsDocumentViewer } from "./checkIsDocumentViewer";

export function turnPage(page: number, canvInstance: typeof canv) {
    const selectedEntities = canvInstance.canvasController.selected;

    if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
        const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
        if (child && checkIsDocumentViewer(child)) {
            child.goToPage(page);
        }
    }
}
